// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ec4ee0cb","455":"35a69e2b","488":"c9b4557a"}[chunkId] + ".chunk.js";
};